export default "__VITE_ASSET__BONQc7Y5__"